/**
 * Typed ThunkAction
 */
export let ActionType;

(function (ActionType) {
  ActionType["FETCH_VESTING_SAFE_CONFIG_REQUESTED"] = "FETCH_VESTING_SAFE_CONFIG_REQUESTED";
  ActionType["FETCH_VESTING_SAFE_CONFIG_SUCCESS"] = "FETCH_VESTING_SAFE_CONFIG_SUCCESS";
  ActionType["FETCH_VESTING_SAFE_CONFIG_FAILURE"] = "FETCH_VESTING_SAFE_CONFIG_FAILURE";
  ActionType["FETCH_VESTING_SAFE_REQUESTED"] = "FETCH_VESTING_SAFE_REQUESTED";
  ActionType["FETCH_VESTING_SAFE_SUCCESS"] = "FETCH_VESTING_SAFE_SUCCESS";
  ActionType["FETCH_VESTING_SAFE_FAILURE"] = "FETCH_VESTING_SAFE_FAILURE";
  ActionType["FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_REQUESTED"] = "FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_REQUESTED";
  ActionType["FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_SUCCESS"] = "FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_SUCCESS";
  ActionType["FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_FAILURE"] = "FETCH_VESTING_SAFE_REMAINING_CLAIM_COUNT_FAILURE";
  ActionType["FETCH_CLAIM_VESTING_SAFE_REQUESTED"] = "FETCH_CLAIM_VESTING_SAFE_REQUESTED";
  ActionType["FETCH_CLAIM_VESTING_SAFE_SUCCESS"] = "FETCH_CLAIM_VESTING_SAFE_SUCCESS";
  ActionType["FETCH_CLAIM_VESTING_SAFE_FAILURE"] = "FETCH_CLAIM_VESTING_SAFE_FAILURE";
})(ActionType || (ActionType = {}));

export { AppError } from '@wolffun/shared/src/types';